import { Session } from 'src/models/Session';
import { Session as SessionComponent } from 'src/components';
import { SessionsService } from 'src/services';
import { useMemo, useState } from 'react';
import { useQueryClient } from 'react-query';
import {
  PlaylistActionsMenu,
  PlaylistPlaybackBar,
  resolvePlaylistContentType,
} from 'src/features/AddToPlaylist';

const invalidateLikesQueries = (queryClient: ReturnType<typeof useQueryClient>) => {
  void queryClient.invalidateQueries(['shortActivityList', 'Ulubione']);
  void queryClient.invalidateQueries(['likes']);
};

const SessionDetails: React.FC<
  Session & {
    toggleCompleted: () => void;
    pathBaseSegment?: string;
  }
> = ({
  toggleCompleted,
  pathBaseSegment,
  ...session
}) => {
  const queryClient = useQueryClient();
  const playlistContentType = useMemo(
    () =>
      resolvePlaylistContentType(session, pathBaseSegment),
    [session, pathBaseSegment],
  );

  const [advanceSignal, setAdvanceSignal] = useState(0);

  return (
    <>
      <PlaylistPlaybackBar
        sessionContentId={session.id}
        sessionContentType={playlistContentType}
        advanceSignal={advanceSignal}
      />
      <SessionComponent
        contentType={session.contentType}
        title={session.title}
        underline={session.underline}
        difficulty={session.difficulty}
        primaryDescription={session.primaryDescription}
        secondaryDescription={session.secondaryDescription}
        coach={session.coach}
        style={session.style as any}
        type={session.type as any}
        tag={session.tag as any}
        equipment={session.equipment as any}
        video={session.video}
        horizontalThumbnail={session.horizontalThumbnail}
        attachments={session.extras}
        duration={session.video?.duration}
        isLiked={session.isLiked}
        toggleLike={(liked) =>
          SessionsService.toggleLiked(session.id, liked).then(() =>
            invalidateLikesQueries(queryClient),
          )
        }
        likesCount={session.likesCount}
        isLikedByUser={session.isLikedByUser}
        togglePublicLike={() => SessionsService.toggleSessionLike(session.id)}
        isCompleted={session.isCompleted}
        toggleCompleted={toggleCompleted}
        onVideoPlaybackComplete={() => setAdvanceSignal((n) => n + 1)}
        playlistActions={
          <PlaylistActionsMenu
            contentId={session.id}
            contentType={playlistContentType}
            variant="detail"
          />
        }
        entityId={session.id}
        entityType="session"
      />
    </>
  );
};

export default SessionDetails;
